import connect from 'react-redux/es/connect/connect';
import GuestPage from '../components/GuestPage';
import { loginAsCustomerWithId, updateGuest } from '../actions/user';

const mapStateToProps = state => ({
    loggedInUser: state.user.user,
    customer: state.user.customer
});

const mapDispatchToProps = dispatch => ({
    updateGuest: guestData => {
        return dispatch(updateGuest(guestData));
    },
    loginAsCustomerWithId: (customerId, showModal, onError, onSuccess) => {
        dispatch(loginAsCustomerWithId(customerId, showModal, onError, onSuccess));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(GuestPage);
